<div>
    <app-page-breadcrumb pageTitle="Guías de Remisión" />

    <div
        class="mb-4 flex justify-end rounded-2xl border border-gray-200 bg-white px-4 py-4 dark:border-gray-800 dark:bg-white/[0.03]">
        <button type="button"
            class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600 transition-colors"
            (click)="onCreateGuide()">
            + Nueva guía
        </button>
        <button type="button"
            class="ml-2 inline-flex items-center gap-2 rounded-lg bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 transition-colors"
            (click)="loadGuides()" [disabled]="loadingTable">
            {{ loadingTable ? 'Actualizando…' : 'Actualizar' }}
        </button>
    </div>

    <div
        class="min-h-[60vh] rounded-2xl border border-gray-200 bg-white px-3 py-5 dark:border-gray-800 dark:bg-white/[0.03] xl:px-4 xl:py-5">

        <div class="rounded-2xl border border-gray-200 bg-white pt-4 dark:border-white/5 dark:bg-white/[0.03]">

            <!-- HEADER: título + buscador -->
            <div class="flex flex-col gap-2 px-5 mb-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
                <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">
                    Listado de guías de remisión
                </h3>
                <div class="relative">
                    <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </div>
                    <input type="text" placeholder="Buscar por serie, destinatario, motivo..."
                        (input)="setSearchTerm($any($event.target).value)"
                        class="dark:bg-dark-900 h-[42px] w-full rounded-lg border border-gray-300 bg-transparent py-2.5 pl-9 pr-4 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 xl:w-[300px]" />
                </div>
            </div>

            <!-- TABLA -->
            <div class="overflow-hidden">
                <div class="max-w-full px-5 overflow-x-auto sm:px-6">
                    <table class="w-full min-w-215">

                        <thead class="border-y border-gray-100 dark:border-white/5">
                            <tr class="text-gray-500 dark:text-gray-400 text-left text-xs uppercase tracking-wider">
                                <th class="w-[10%] py-3 font-medium">Serie / N°</th>
                                <th class="w-[38%] py-3 font-medium">
                                    <button class="inline-flex items-center gap-1 hover:text-gray-700 dark:hover:text-gray-200" (click)="toggleSort('destinatario')">
                                        Destinatario
                                        <svg class="w-3.5 h-3.5" [class.text-brand-500]="sortColumn === 'destinatario'" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                            @if (sortColumn === 'destinatario' && sortDir === 'asc') {
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
                                            } @else if (sortColumn === 'destinatario' && sortDir === 'desc') {
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                            } @else {
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
                                            }
                                        </svg>
                                    </button>
                                </th>
                                <th class="w-[10%] py-3 font-medium">Motivo</th>
                                <th class="w-[10%] py-3 font-medium">Transporte</th>
                                <th class="w-[10%] py-3 font-medium">Fecha traslado</th>
                                <th class="w-[10%] py-3 font-medium">Estado SUNAT</th>
                                <th class="w-[12%] py-3 font-medium">Acciones</th>
                            </tr>
                        </thead>

                        <tbody class="divide-y divide-gray-100 dark:divide-white/5">

                            @if (loadingTable) {
                            <tr>
                                <td colspan="7" class="py-10 text-center text-sm text-gray-400">
                                    <svg class="w-8 h-8 mx-auto mb-2 animate-spin" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                            stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                    </svg>
                                    Cargando guías…
                                </td>
                            </tr>
                            } @else if (filteredGuides.length === 0) {
                            <tr>
                                <td colspan="7" class="py-10 text-center text-sm text-gray-400">
                                    No hay guías de remisión registradas.
                                </td>
                            </tr>
                            } @else {
                            @for (guide of currentItems; track guide.id) {
                            <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/40 transition-colors">

                                <!-- Serie / N° -->
                                <td class="py-3 pr-4 font-mono text-sm text-gray-800 dark:text-white">
                                    @if (guide.series && guide.sequence) {
                                    <span class="font-semibold">{{ guide.series }}-{{ guide.sequence }}</span>
                                    } @else {
                                    <span class="text-gray-400 italic text-xs">Sin emitir</span>
                                    }
                                </td>

                                <!-- Destinatario -->
                                <td class="py-3 pr-4">
                                    <p class="font-medium text-gray-800 dark:text-white text-sm">
                                        {{ guide.client ? (guide.client.businessName || (guide.client.firstName + ' ' + guide.client.lastName)) : '—' }}
                                    </p>
                                    <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                        {{ guide.client?.documentType }}: {{ guide.client?.documentNumber }}
                                    </p>
                                </td>

                                <!-- Motivo -->
                                <td class="py-3 pr-4 text-sm text-gray-700 dark:text-gray-300">
                                    {{ getTransferReasonLabel(guide.transferReason) }}
                                </td>

                                <!-- Transporte -->
                                <td class="py-3 pr-4">
                                    <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                                        [ngClass]="guide.transportMode === 'TRANSPORTE_PUBLICO'
                                            ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300'
                                            : 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300'">
                                        {{ getTransportModeLabel(guide.transportMode) }}
                                    </span>
                                </td>

                                <!-- Fecha traslado -->
                                <td class="py-3 pr-4 text-sm text-gray-600 dark:text-gray-400">
                                    {{ formatDate(guide.transferDate) }}
                                </td>

                                <!-- Estado SUNAT -->
                                <td class="py-3 pr-4">
                                    @if (guide.status) {
                                    <div class="inline-block"
                                        (mouseenter)="showTooltip($event, guide.sunatResponseCode, guide.sunatMessage)"
                                        (mouseleave)="hideTooltip()">
                                        <app-badge size="sm" [color]="getStatusBadgeColor(guide.status)">
                                            {{ guide.status }}
                                        </app-badge>
                                    </div>
                                    } @else {
                                    <span class="text-xs text-gray-400">-</span>
                                    }
                                </td>

                                <!-- Acciones -->
                                <td class="py-3">
                                    <div class="flex items-center gap-2">
                                        <button type="button"
                                            class="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors"
                                            (click)="onViewGuide(guide)">
                                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                            Detalle
                                        </button>
                                        @if (guide.pdfUrl) {
                                        <button type="button"
                                            class="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium text-white rounded-md bg-red-500 hover:bg-red-600 transition-colors"
                                            (click)="openPdf(guide.pdfUrl!)">
                                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M9 13h6M9 17h6M9 9h3" />
                                            </svg>
                                            PDF
                                        </button>
                                        }
                                    </div>
                                </td>

                            </tr>
                            }
                            }

                        </tbody>
                    </table>
                </div>
            </div>

            <!-- PAGINACIÓN -->
            <div class="px-6 py-4 border-t border-gray-200 dark:border-white/5">
                <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <div class="flex items-center gap-2">
                        <span class="text-sm text-gray-500 dark:text-gray-400">Mostrar</span>
                        <select class="h-9 rounded-lg border border-gray-300 bg-white px-2 text-sm text-gray-700 focus:border-brand-300 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300"
                            (change)="onPageSizeChange(+$any($event.target).value)">
                            @for (opt of pageSizeOptions; track opt) {
                            <option [value]="opt" [selected]="opt === itemsPerPage">{{ opt }}</option>
                            }
                        </select>
                        <span class="text-sm text-gray-500 dark:text-gray-400">registros</span>
                    </div>
                    <div class="flex items-center justify-between sm:justify-end gap-1">
                        <button type="button" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)"
                            class="px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>
                        <span class="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300">
                            {{ currentPage }} / {{ totalPages }}
                        </span>
                        <button type="button" [disabled]="currentPage === totalPages"
                            (click)="goToPage(currentPage + 1)"
                            class="px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- REGISTER / VIEW MODAL -->
<app-remission-guide-register [isOpen]="showForm" [selectedGuide]="selectedGuide" (onClose)="onCloseForm()"
    (onSaved)="onSaved()">
</app-remission-guide-register>

@if (tooltipVisible) {
<div class="fixed z-9999 w-80 rounded-lg bg-gray-900 px-3 py-2 text-xs text-white shadow-lg dark:bg-gray-700 pointer-events-none"
    [style.left.px]="tooltipX"
    [style.top.px]="tooltipY - 8"
    [style.transform]="'translateY(-100%)'">
    <span class="font-semibold">{{ tooltipCode }}:</span> {{ tooltipText }}
</div>
}